module.exports = __webpack_public_path__ + "static/media/logo.36f7f299.png";